import React from "react";
import { Link } from "react-router-dom";

const cols = [
  {
    title: "Workspace Products",
    links: ["CommodityBid™️", "FreightIQ™️", "Inspection™️", "Live Tracking™️", "RFQ™️"],
  },
  {
    title: "Platform",
    links: ["For Buyers", "For Manufacturers", "Security", "Trust"],
  },
  {
    title: "Company",
    links: ["About DeMaxtore", "Careers", "Press", "Contact"],
  },
  {
    title: "Resources",
    links: ["Documentation", "Procurement Guide", "Status", "Changelog"],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#0B1F3A] text-white pt-20 pb-10 relative overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-[1.4fr_repeat(4,1fr)] gap-10 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center">
              <div className="flex flex-col leading-tight">
                <span className="font-display font-bold text-white text-[15px] tracking-tight">DeMaxtore</span>
                <span className="font-inter text-[10px] font-medium tracking-[0.18em] uppercase text-white/60">
                  Workspace Platform
                </span>
              </div>
            </Link>
            <p className="mt-5 text-[13px] leading-relaxed text-white/65 max-w-xs">
              The online procurement bidding workspace for global buyers and
              verified Turkish manufacturers.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-[11.5px] font-medium text-white/70 bg-white/[0.06] border border-white/10 rounded-lg px-3 py-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
              All systems operational
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <p className="font-inter text-[10px] font-bold tracking-[0.22em] uppercase text-white/45">
                {c.title}
              </p>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <Link
                      to="/contact"
                      className="text-[13.5px] text-white/75 hover:text-white transition-colors"
                    >
                      {l}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[12px] text-white/55">
          <p>© {new Date().getFullYear()} DeMaxtore. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/contact" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
